import './single-post.scss';

// Builds the "In this article" table of contents from the article's <h2>
// headings and highlights the section in view (scrollspy). Recycled from Pine.
const initSinglePostToc = (): void => {
	const article = document.querySelector<HTMLElement>( '.single-post__article' );
	const toc     = document.querySelector<HTMLElement>( '.post-toc' );
	const tocList = document.querySelector<HTMLElement>( '.post-toc__list' );

	if ( ! article || ! toc || ! tocList ) {
		return;
	}

	const headings = Array.from( article.querySelectorAll<HTMLHeadingElement>( 'h2' ) );

	if ( headings.length === 0 ) {
		toc.classList.add( 'post-toc--empty' );
		return;
	}

	headings.forEach( ( heading, index ) => {
		if ( ! heading.id ) {
			const slug = ( heading.textContent || '' )
				.trim()
				.toLowerCase()
				.replace( /[^\w\s-]/g, '' )
				.replace( /\s+/g, '-' )
				.substring( 0, 60 ) || `section-${ index }`;
			heading.id = slug;
		}

		const item = document.createElement( 'li' );
		item.className = 'post-toc__item';
		item.dataset.index = String( index );
		item.innerHTML =
			'<span class="post-toc__indicator" aria-hidden="true"></span>' +
			`<a class="post-toc__link" href="#${ heading.id }"></a>`;
		const link = item.querySelector<HTMLAnchorElement>( '.post-toc__link' );
		if ( link ) {
			link.textContent = heading.textContent?.trim() ?? '';
		}
		tocList.appendChild( item );
	} );

	const items = Array.from( tocList.querySelectorAll<HTMLLIElement>( '.post-toc__item' ) );
	let activeIndex = -1;

	const setActive = ( index: number ): void => {
		if ( index === activeIndex ) {
			return;
		}
		if ( activeIndex >= 0 ) {
			items[ activeIndex ]?.classList.remove( 'post-toc__item--active' );
		}
		activeIndex = index;
		if ( activeIndex >= 0 ) {
			items[ activeIndex ]?.classList.add( 'post-toc__item--active' );
		}
	};

	setActive( 0 );

	const prefersReducedMotion = window.matchMedia( '(prefers-reduced-motion: reduce)' ).matches;
	let suppressUntil = 0;

	items.forEach( ( item, index ) => {
		const link = item.querySelector<HTMLAnchorElement>( '.post-toc__link' );
		if ( ! link ) {
			return;
		}
		link.addEventListener( 'click', ( event ) => {
			setActive( index );
			suppressUntil = Date.now() + 800;
			if ( ! prefersReducedMotion ) {
				event.preventDefault();
				headings[ index ].scrollIntoView( { behavior: 'smooth', block: 'start' } );
				history.pushState( null, '', `#${ headings[ index ].id }` );
			}
		} );
	} );

	if ( prefersReducedMotion ) {
		return;
	}

	const observer = new IntersectionObserver(
		( entries ) => {
			if ( Date.now() < suppressUntil ) {
				return;
			}
			entries.forEach( ( entry ) => {
				if ( entry.isIntersecting ) {
					const idx = headings.indexOf( entry.target as HTMLHeadingElement );
					if ( idx !== -1 ) {
						setActive( idx );
					}
				}
			} );
		},
		{ rootMargin: '-10% 0% -70% 0%', threshold: 0 }
	);

	headings.forEach( ( h ) => observer.observe( h ) );
};

if ( document.readyState !== 'loading' ) {
	initSinglePostToc();
} else {
	document.addEventListener( 'DOMContentLoaded', initSinglePostToc );
}
